module.exports = __webpack_public_path__ + "img/project-nft.82563769.png";